// extracted by mini-css-extract-plugin
export var visibleStyle = "index-module--visibleStyle--2GpBV";
export var currencyButton = "index-module--currencyButton--fLUdo";
export var labelContainer = "index-module--labelContainer--3g-FR";
export var item = "index-module--item--2Gpii";
export var label = "index-module--label--3et_m";
export var text = "index-module--text--2NGZE";
export var message = "index-module--message--2u_sB";
export var arrow = "index-module--arrow--3dD_6";
export var flagIcon = "index-module--flagIcon--2ezW9";